import { createStore } from "vuex";
import securedWebStorage from '@/main';
import filterModule from './filterModule';
import api_provider from '../providers/api_provider';
import urls_server from '../config/urls_server';


export default createStore({
  state: {
    inited: false,
    isAuthenticated: false,
    id : '',
    name : '',
    profile : '',
    role: '',
    avatar : '',
    category : '',
    id_company: '',
    isDemo: false,

    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isTransparent: "",
    isRTL: false,
    mcolor: "",
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,

    canViewClient: false,
    canViewCompany: false,
    canViewSystemRoles: false,
    isCompanyAdmin: false,
    // menuModules: [],
  },
  modules: {
    filter: filterModule,
  },
  mutations: {
    // ------------securedWebStorage---------------
    initializeStore(state){
      // BFF opaco: el token vive en cookie HttpOnly. La sesión del front se restaura
      // desde el perfil no sensible persistido (no desde el token).
      const parse = (key) => {
        const raw = securedWebStorage && securedWebStorage.getItem(key);
        try { return raw ? JSON.parse(raw) : null; } catch (e) { return raw; }
      };
      if (parse("id")) {
        state.isAuthenticated = true;
        state.id = parse("id");
        state.name = parse("name");
        state.profile = parse("profile");
        state.role = parse("role");
        state.category = parse("category");
        state.avatar = parse("avatar");
        state.isDemo = parse("isDemo") === true;
        this.commit("setPermissions", state.role);
      } else {
        state.isAuthenticated = false;
      }
    },
    setSession(state, user) {
      // Inicia la sesión a partir del perfil que entrega el BFF (sin token en JS).
      state.isAuthenticated = true;
      this.commit("setUserInfo", {
        id: user.id, name: user.name, profile: user.profile,
        role: user.role, category: user.category, avatar: user.avatar,
        isDemo: user.is_demo,
      });
      this.commit("setPermissions", user.role);
    },
    initCompanyId(state) {
      const savedCompany = securedWebStorage.getItem("id_company");
      if (savedCompany) {
        state.id_company = JSON.parse(savedCompany);
      }
    },
    setIdCompany(state, company) {
      // console.log("company", company)
      if(company){
        state.id_company = company;
        securedWebStorage.setItem("id_company", JSON.stringify(company));
      }
    },
    setUserInfo(state, user_info) {
      state.id = user_info.id;
      state.name = user_info.name;
      securedWebStorage.setItem("id", JSON.stringify(user_info.id));
      securedWebStorage.setItem("name", JSON.stringify(user_info.name));

      if (user_info.profile != ''){
        state.profile = user_info.profile;
        securedWebStorage.setItem("profile", JSON.stringify(user_info.profile));
      }

      if (user_info.role != ''){
        state.role = user_info.role;
        securedWebStorage.setItem("role", JSON.stringify(user_info.role));
      }

      if (user_info.category != ''){
        state.category = user_info.category;
        securedWebStorage.setItem("category", JSON.stringify(user_info.category));
      }

      if (user_info.avatar != ''){
        state.avatar = user_info.avatar;
        securedWebStorage.setItem("avatar", JSON.stringify(user_info.avatar));
      }

      // Modo demo: se guarda siempre (incluido false) porque es un booleano.
      state.isDemo = !!user_info.isDemo;
      securedWebStorage.setItem("isDemo", JSON.stringify(state.isDemo));
    },
    setPermissions(state, role) {
      if (role === 'WISETRACK_ADMIN') { // SUPER ADMIN
        state.canViewCompany = true;
        state.canViewSystemRoles = true;
      } else if (role === 'MANDANTE_ADMIN') { // MANDANTE ADMIN
        state.canViewCompany = false;
        state.isCompanyAdmin = true;
        state.canViewSystemRoles = true;
      } else { // USER
        state.canViewCompany = false;
        state.isCompanyAdmin = false;
        state.canViewSystemRoles = false;
      }

      // Verifica si puede ver campo Cliente
      if (role === 'WISETRACK_ADMIN' || role === 'MANDANTE_ADMIN') {
        state.canViewClient = true;
      } else {
        state.canViewClient = false;
      }
    },
    clearState(state) {
      state.isAuthenticated = false;
      state.id_company =  ''
      // Se purgan tokens legacy de sesiones previas al esquema de cookies HttpOnly.
      securedWebStorage.deleteItem('access');
      securedWebStorage.deleteItem('refresh');
      securedWebStorage.deleteItem('id_company');

      state.id =  ''
      state.name =  ''
      state.profile =  ''
      state.role = ''
      state.category =  ''
      state.avatar =  ''
      state.canViewClient = false;
      state.canViewCompany = false;
      state.canViewSystemRoles = false;
      state.isCompanyAdmin = false;
      securedWebStorage.deleteItem('id');
      securedWebStorage.deleteItem('name');
      securedWebStorage.deleteItem('profile');
      securedWebStorage.deleteItem('role');
      securedWebStorage.deleteItem('category');
      securedWebStorage.deleteItem('avatar');
      securedWebStorage.deleteItem('isDemo');
      state.isDemo = false;
      // state.menuModules = []
    },
    // --------FINALE securedWebStorage------------

    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      const sidenav = document.getElementById("sidenav-main");

      if (sidenav_show.classList.contains("g-sidenav-pinned")) {
        sidenav_show.classList.remove("g-sidenav-pinned");
        setTimeout(function () {
          sidenav.classList.remove("bg-white");
        }, 100);
        sidenav.classList.remove("bg-transparent");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-pinned");
        sidenav.classList.add("bg-white");
        sidenav.classList.remove("bg-transparent");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.isTransparent = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
  },
  getters: {
    getName: (state) => state.name,
    getCategory: (state) => state.category,
    getProfile: (state) => state.profile,
    getRole: (state) => state.role,
    getAvatar: (state) => state.avatar,
    canViewCompany: (state) => state.canViewCompany,
    canViewSystemRoles: (state) => state.canViewSystemRoles,
    isCompanyAdmin: (state) => state.isCompanyAdmin,
    canViewClient: (state) => state.canViewClient,
    getIdCompany: (state) => state.id_company,
    // Empresa elegida en la plataforma (la que manda el interceptor como company_id), o null.
    scopeCompanyId: (state) => state.id_company || null,
    loggedIn (state) {
        return state.isAuthenticated
      },
  },

});
